import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiSdkService } from 'src/app/services/api-sdk.service';
import { CreditsPackI } from 'src/app/interfaces/credits.interface';

@Component({
  selector: 'app-buy-credits-modal',
  templateUrl: './buy-credits-modal.component.html',
  styleUrls: ['./buy-credits-modal.component.scss']
})
export class BuyCreditsModalComponent implements OnInit {
  creditsPacks: CreditsPackI[] = [];
  selectedPack: CreditsPackI | null = null;
  loading = true;
  purchasing = false;
  error: string | null = null;

  constructor(
    private modalCtrl: ModalController,
    private apiSdkService: ApiSdkService
  ) {}

  async ngOnInit() {
    await this.loadCreditsPacks();
  }

  async loadCreditsPacks() {
    this.loading = true;
    this.error = null;

    try {
      const result = await this.apiSdkService.getCreditsPacks();
      if (result?.success?.data) {
        this.creditsPacks = result.success.data;
      }
    } catch (err) {
      console.error('Error loading credits packs:', err);
      this.error = 'Failed to load credits packs. Please try again.';
    } finally {
      this.loading = false;
    }
  }

  selectPack(pack: CreditsPackI) {
    this.selectedPack = pack;
  }

  getDiscount(pack: CreditsPackI): number | null {
    // Calculate discount percentage based on price per credit
    const basePrice = 0.1; // 0.1 euro per credit (200 credits = 20 euros base)
    const actualPricePerCredit = pack.price / pack.quantity;
    const discount = Math.round((1 - actualPricePerCredit / basePrice) * 100);
    return discount > 0 ? discount : null;
  }

  getPricePerCredit(pack: CreditsPackI): string {
    return (pack.price / pack.quantity).toFixed(2);
  }

  async purchaseCredits() {
    if (!this.selectedPack?._id) {
      return;
    }

    this.purchasing = true;
    this.error = null;

    try {
      const result = await this.apiSdkService.createCreditsCheckout(this.selectedPack._id);

      if (result?.success?.checkoutUrl) {
        // Redirect to Stripe checkout
        window.location.href = result.success.checkoutUrl;
      } else {
        this.error = 'Failed to create checkout session. Please try again.';
      }
    } catch (err) {
      console.error('Error creating checkout:', err);
      this.error = 'Failed to process purchase. Please try again.';
    } finally {
      this.purchasing = false;
    }
  }

  async close() {
    await this.modalCtrl.dismiss();
  }
}
